import { Injectable } from '@angular/core';
import { GtagService } from './gtag.service';

@Injectable({
  providedIn: 'root',
})
export class GtagCommunityService extends GtagService {
  viewPost(postUuid: string): void {
    const { datetime, OS, user_id } = this.getBaseParams();

    this.log('view_post', { datetime, OS, user_id, post_id: postUuid });
  }

  socialClick(postUuid: string, social: string): void {
    const { datetime, OS, user_id } = this.getBaseParams();

    this.log('social_click', {
      post_id: postUuid,
      datetime,
      OS,
      user_id,
      social,
    });
  }

  textButtonClick(postUuid: string): void {
    const { datetime, OS, user_id } = this.getBaseParams();

    this.log('text_button_click', {
      datetime,
      OS,
      user_id,
      post_id: postUuid,
    });
  }

  watchButtonClick(postUuid: string): void {
    const { datetime, OS, user_id } = this.getBaseParams();

    this.log('watch_button_click', {
      datetime,
      OS,
      user_id,
      post_id: postUuid,
    });
  }
}
